import { Classes, ISelectOption, Select } from '@pinpointhq/thumbtack';
import * as React from 'react';

interface ITextInsert {
  targetRef?: React.RefObject<HTMLInputElement> | React.RefObject<HTMLTextAreaElement>;
  items: { value: string; text: string; caption?: string }[];
  label: string;
  onInsert(code: string): void;
  usePortal?: boolean;
}

export function TextInsert({ items, onInsert, targetRef, label, usePortal = false }: ITextInsert) {
  // http://stackoverflow.com/questions/1064089/inserting-a-text-where-cursor-is-using-javascript-jquery
  const handleInsert = (text: string) => {
    if (targetRef) {
      const input = targetRef.current;
      const currentVal = input.value;
      const cursorPosition = input.selectionStart;
      const front = currentVal.substring(0, cursorPosition);
      const back = currentVal.substring(cursorPosition, currentVal.length);
      const newVal = `${front}{{ ${text} }}${back}`;
      onInsert(newVal);

      // This should set the cursor position but it doesnt work - I assume due to the fact that
      // React is updating the state or something
      // const newCursorPos = cursorPosition + text.length;
      // input.setSelectionRange(newCursorPos, newCursorPos);
      input.focus();
    } else {
      onInsert(`{{ ${text} }}`);
    }
  };

  const handleSelect = (selectedItem: ISelectOption) => {
    handleInsert(selectedItem.value);
  };

  const selectItems = items.map((item) => ({ label: item.text, value: item.value, caption: item.caption }));

  return (
    <Select
      items={selectItems}
      onItemSelect={handleSelect}
      placeholder={label}
      usePortal={usePortal}
      buttonProps={{ className: `${Classes.BUTTON} ${Classes.MINIMAL}` }}
      resetOnSelect={true}
    />
  );
}
